export const SET_APPEALS_MODAL_FYI_VIEWED = 'SET_APPEALS_MODAL_FYI_VIEWED';
export const SET_BAN_POLICY = 'SET_BAN_POLICY';
